import { NSAHomePage, NSARouterMakerResult } from "namirasoft-account-react";
import { NSColumn, NSPanel, NSSpace, NSSpaceSizeType } from "namirasoft-site-react";
import { Component } from "react";
import HomeEntities from "../components/HomeEntities";
import InferencerGraph from "../components/InferencerGraph";
import InferencerJungleLoader from "../components/InferencerJungleLoader";
import UsageChart from "../components/UsageChart";
import { InferenceInfo } from "../InferenceInfo";
import { InferenceLayout } from "../InferenceLayout";
import { InferenceRouterProps } from "../InferenceRouterProps";

interface HomePageProps extends NSARouterMakerResult, InferenceRouterProps { }

class HomePage extends Component<HomePageProps>
{
    override render()
    {
        return (
            <InferenceLayout {...this.props} action={{ description: InferenceInfo.home }}>
                <NSAHomePage
                    {...this.props}
                    getChildren={{
                        getChildrenBetween: () => (
                            <NSColumn style={{ width: "100%", gap: 0 }}>
                                <NSPanel style={{ padding: "16px", width: "100%" }}>
                                    <UsageChart
                                        {...this.props}
                                        title="Usage Across All Inferencers"
                                    />
                                </NSPanel>
                                <NSSpace size={NSSpaceSizeType.NORMAL} />
                                <NSPanel style={{ padding: "16px", width: "100%" }}>
                                    <InferencerJungleLoader
                                        {...this.props}
                                        render={({ roots, loading, error }) => (
                                            <InferencerGraph
                                                forest={roots}
                                                loading={loading}
                                                error={error}
                                                height={560}
                                            />
                                        )}
                                    />
                                </NSPanel>
                                <NSSpace size={NSSpaceSizeType.NORMAL} />
                                <HomeEntities {...this.props} />
                            </NSColumn>
                        ),
                    }}
                />
            </InferenceLayout>
        )
    }
}

export default HomePage;